import Vue from "vue";

// axios
import axios from "axios";
const endpointUgemsUniv = process.env.VUE_APP_API_URL_UGEMS_UNIV
  ? process.env.VUE_APP_API_URL_UGEMS_UNIV
  : `http://localhost:3106`;

const axiosIns = axios.create({
  // You can add your headers here
  // ================================
  // baseURL: '/api',
  // baseURL: 'https://5f45-2001-448a-2020-3be3-81d8-774f-f420-6a31.ap.ngrok.io/hms/api',
  baseURL: endpointUgemsUniv,
  timeout: Number(process.env.VUE_APP_API_TIMEOUT_MS || 30000),
  headers: {
    "Content-Type": "application/json",
    // "ngrok-skip-browser-warning": true,

  },
});

axiosIns.interceptors.request.use(
  (config) => {
    const token_auth = localStorage.getItem("ugems-accessToken");
    if (token_auth) {
      config.headers.Authorization = `Bearer ${token_auth}`;
    }
    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

axiosIns.interceptors.response.use(
  function (response) {
    return response;
  },
  function (error) {
    // if(!(router.history.current.path).includes("login") && error.response.status == 401){
    //   console.log('path is not login & status code 401');

    //   // Remove userData from localStorage
    //   localStorage.removeItem('userData')

    //   // Redirect to login page
    //   router.push({ name: 'auth-login' })
    // }
    // console.log(`error : ${error.response.status}`);
    return Promise.reject(error);
  }
);

Vue.prototype.$http = axiosIns;

export default axiosIns;
